import { render } from "./PreflightInfo.vue?vue&type=template&id=3c8b7c63"
import script from "./PreflightInfo.vue?vue&type=script&lang=js"
export * from "./PreflightInfo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__